import successIcon from "assets/img/success-icon.png";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupForm7Props = CustomComponentProps & {
    step: number;
};

const SignupForm7 = ({ step, className, style }: SignupForm7Props) => {
    return (
        <div
            id="signup-panel-7"
            className={`process-panel-wrap is-narrow ${className} ${step == 6 ? "is-active" : ""}`}
            style={style}
        >
            <div className="form-panel">
                <img className="success-image" src={successIcon} alt="" />
                <div className="success-text">
                    <h3>Congratz, you successfully created your account.</h3>
                    <a
                        href="#"
                        id="signup-finish"
                        className="button is-fullwidth"
                    >
                        Let Me In
                    </a>
                </div>
            </div>
        </div>
    );
};

export default SignupForm7;
